<template>
    <Modal
        :is-open="showRedemptionCreateModal"
        title="Add redemption"
        @close="tripsStore.closeModal()"
    >
        <template #content>
            <div class="mb-8">
                <RedemptionStep1 v-if="redemptionStep === 1" />
                <RedemptionStep2 v-if="redemptionStep === 2" />
                <RedemptionStep3 v-if="redemptionStep === 3" />
            </div>
            <StepIndicator />
        </template>
        <template #errors>
            <div class="flex justify-center">
                <Errors :errors="errors" />
            </div>
        </template>
        <template #footer>
            <StepsActions />
        </template>
    </Modal>
</template>
<script setup>
import { storeToRefs } from 'pinia';
import { useTripsStore } from '@/store/trips';
import Modal from '@/components/ui/modal/ui-modal.vue';
import Errors from '@/components/errors.vue';
import RedemptionStep1 from '@/components/trips/modals/steps/redemption-step-1.vue';
import RedemptionStep2 from '@/components/trips/modals/steps/redemption-step-2.vue';
import RedemptionStep3 from '@/components/trips/modals/steps/redemption-step-3.vue';
import StepIndicator from '@/components/trips/modals/steps/step-indicator.vue';
import StepsActions from '@/components/trips/modals/steps/steps-actions.vue';

const tripsStore = useTripsStore();

const { showRedemptionCreateModal, redemptionStep, errors } =
    storeToRefs(tripsStore);
</script>
